import Vue from 'vue'
import App from './App.vue'
import router from './router'

import { registerVueGlobalComponent } from '@/register/vue-global-component.register';

Vue.config.productionTip = false

registerVueGlobalComponent(Vue);

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
